import styled from 'styled-components';

export const FieldLabel = styled.label`
  all: unset;
  color: ${({ theme }) => theme.colors.gray};
  font-size: 11px;
  font-weight: 700;
  opacity: 0.8;
  text-transform: uppercase;

  &[for] {
    cursor: pointer;
  }
`;
